// src/hooks/useGetCannonStations.js
import { useState, useEffect, useRef } from 'react';
import { API_URL } from '../config';
import { authFetch } from '../utils';

function useGetCannonStations() {
  const [cannonStations, setCannonStations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [zeusAvailable, setZeusAvailable] = useState(true);

  const firstLoad = useRef(true);

  useEffect(() => {
    let isMounted = true;

    const fetchCannonStations = () => {
      authFetch(`${API_URL}cannons`)
        .then((res) => {
          if (!res.ok) throw new Error('Error al obtener las estaciones de bombeo');
          return res.json();
        })
        .then(({ stations, zeusAvailable: zeus }) => {
          if (!isMounted) return;

          setCannonStations(stations);
          setZeusAvailable(zeus);
          setError(null);
          setIsLoading(false);

          firstLoad.current = false;
        })
        .catch((err) => {
          if (!isMounted) return;

          console.error("Error al obtener estaciones de bombeo:", err);

          if (firstLoad.current) {
            setError(err);
            setIsLoading(false);
          }
        });
    };

    fetchCannonStations();
    const interval = setInterval(fetchCannonStations, 30000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);

  return { cannonStations, isLoading, error, zeusAvailable };
}

export default useGetCannonStations;
